export const GET_USER = "GET_USER";
export const ALL_USER = "ALL_USER";
export const EDIT_USER = "EDIT_USER";
export const ADD_USER = "ADD_USER";





